import styled from "styled-components"

const linkColors = {
  light: "color: #002DC2;",
  white: "color: #002DC2;",
  dark: "color: #ffffff;",
  blue: "color: #ffffff;",
}

export const BlogOL = styled.ol`
  margin-left: 20px;
  padding: 0 0 24px 0px;
  li {
    padding: 5px 0px;
  }
  li::marker {
    font-weight: bold;
  }
  br {
    display: none;
  }
`

export const Quote = styled.div`
  color: #002dc2;
  font-size: 22px;
  line-height: 30px;
  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 24px;
  }
`

export const QuotationGraphic = styled.div`
  margin: 30px 0;
  font-family: News Cycle;
  font-style: normal;
  font-weight: 700;
  font-size: 100px;
  color: #69d1f0;
  transform: rotate(180deg);
  width: fit-content;
  @media (max-width: 576px) {
    font-size: 72px;
  }
`
export const Hyperlink = styled.a`
  ${props => linkColors[props.theme]}
  cursor: pointer;
  text-decoration: underline;
  &:hover,
  &:active,
  &:focus {
    opacity: 0.8;
  }
`
